import { useState } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Formr, formrBuilder, shadcnRenderers } from '@smorgrav/velpr-ui'

interface FormrDemo {
  name: string
  age: number
  active: boolean
  role: string
  skills: string
  birthday: string
  bio: string
}

const initialData: FormrDemo = {
  name: 'Jane Doe',
  age: 30,
  active: true,
  role: 'admin',
  skills: 'react',
  birthday: '1994-06-15T14:30',
  bio: '## Hello\n\nThis is **markdown** content.',
}

const def = formrBuilder<FormrDemo>({})
  .divider('Text & Numbers')
  .stringField('name').label('Name').buildField()
  .numberField('age').label('Age').buildField()
  .divider('Selection')
  .selectField('role', ['admin', 'editor', 'viewer']).label('Role').buildField()
  .multiSelectField('skills', ['react', 'typescript', 'node', 'css', 'go']).label('Skills').buildField()
  .divider('Toggles & Dates')
  .booleanField('active').label('Active').buildField()
  .dateField('birthday').label('Birthday').buildField()
  .divider('Rich Text')
  .markdownField('bio').label('Bio').buildField()
  .buildDef()

export const Route = createFileRoute('/formr')({
  component: FormrTestbed,
})

function FormrTestbed() {
  const [data, setData] = useState<FormrDemo>(initialData)
  const [lastSaved, setLastSaved] = useState<FormrDemo | null>(null)

  return (
    <div className="mx-auto max-w-2xl">
      <h1 className="text-2xl font-bold">Formr Testbed</h1>
      <p className="mt-2 text-muted-foreground">
        All supported FormrTypes rendered with shadcn renderers.
      </p>
      <div className="mt-6">
        <Formr<FormrDemo>
          data={data}
          def={def}
          renderers={shadcnRenderers}
          onSave={(saved) => {
            setData(saved)
            setLastSaved(saved)
          }}
          onReset={() => setData(initialData)}
        />
      </div>
      {lastSaved && (
        <pre className="mt-6 rounded-lg bg-muted p-4 text-sm">
          {JSON.stringify(lastSaved, null, 2)}
        </pre>
      )}
    </div>
  )
}
